(function () {
  'use strict';

  var SUGGESTIONS = [
    "Quality exceeded my expectations",
    "Delivery was super fast",
    "Great value for the price",
    "Feels very premium",
    "Highly recommend this!"
  ];

  var CHIPS_ID = 'jdgm-review-suggestions';
  var chipJustClicked = false; // blocks rebuilding chips immediately after a click

  // ── Remove chips ────────────────────────────────────────────
  function removeSuggestions() {
    var el = document.getElementById(CHIPS_ID);
    if (el) el.remove();
  }

  // ── Build & inject chips below the textarea ─────────────────
  function buildChips(textarea) {
    if (chipJustClicked) return;           // ← flicker guard
    if (document.getElementById(CHIPS_ID)) return;
    if (textarea.value.trim().length >= 15) return;

    var container = document.createElement('div');
    container.id = CHIPS_ID;
    container.className = 'jdgm-review-suggestions';

    SUGGESTIONS.forEach(function (text) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'jdgm-review-suggestions__chip';
      chip.textContent = text;

      chip.addEventListener('mousedown', function (e) {
        e.preventDefault(); // keep textarea focus — no blur fires
      });

      chip.addEventListener('click', function () {
        // Block poller + focus listener from rebuilding chips
        chipJustClicked = true;
        setTimeout(function () { chipJustClicked = false; }, 500);

        textarea.value = textarea.value.trim() === ''
          ? text + ' '
          : textarea.value.trimEnd() + ' ' + text + ' ';

        // Notify Judge.me of the value change
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
        textarea.dispatchEvent(new Event('change', { bubbles: true }));

        removeSuggestions();
        // Note: no textarea.focus() here — mousedown preventDefault kept focus already
      });

      container.appendChild(chip);
    });

    textarea.insertAdjacentElement('afterend', container);
  }

  // ── Attach listeners to a textarea ──────────────────────────
  function attachListeners(textarea) {
    if (textarea._suggestionsAttached) return;
    textarea._suggestionsAttached = true;

    textarea.addEventListener('input', function () {
      var len = textarea.value.trim().length;
      if (len >= 15) {
        removeSuggestions();              // hide when enough text is typed
      } else {
        buildChips(textarea);             // re-show when user deletes back below 15
      }
    });

    textarea.addEventListener('blur', function () {
      setTimeout(function () {
        var chips = document.getElementById(CHIPS_ID);
        if (chips && document.activeElement && !chips.contains(document.activeElement)) {
          removeSuggestions();
        }
      }, 150);
    });

    textarea.addEventListener('focus', function () {
      buildChips(textarea); // chipJustClicked guard inside buildChips prevents flicker
    });
  }

  // ── Find Judge.me textarea inside a DOM node ─────────────────
  function findTextarea(root) {
    if (!root || root.nodeType !== 1) return null;
    // Is the node itself the textarea?
    if (
      root.tagName === 'TEXTAREA' && (
        root.id === 'jdgm-review-body-input' ||
        (root.classList && root.classList.contains('jdgm-write-review-modal__field-input'))
      )
    ) return root;
    // Otherwise search inside it (no broad querySelector — check id first, then class)
    return root.querySelector('textarea#jdgm-review-body-input') ||
           root.querySelector('textarea.jdgm-write-review-modal__field-input') ||
           null;
  }

  // ── MutationObserver — fires only when DOM actually changes ──
  // Zero cost when the review modal is closed. No constant polling.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var ta = findTextarea(added[j]);
        if (ta) {
          attachListeners(ta);
          buildChips(ta);
          return; // found it — no need to keep scanning this batch
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ── One-time check on load (covers pre-rendered widgets) ─────
  (function () {
    var ta = document.querySelector('textarea#jdgm-review-body-input') ||
             document.querySelector('textarea.jdgm-write-review-modal__field-input');
    if (ta) { attachListeners(ta); buildChips(ta); }
  })();

  // ── focusin delegation — zero-cost safety net ────────────────
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'TEXTAREA') return;
    if (
      el.id === 'jdgm-review-body-input' ||
      (el.classList && el.classList.contains('jdgm-write-review-modal__field-input')) ||
      (el.closest && el.closest('.jdgm-write-review-modal')) ||
      (el.closest && el.closest('.jdgm-form'))
    ) {
      attachListeners(el);
      buildChips(el);
    }
  }, true);

})();
